/** @file ikCross: cross product of two vectors (private stand-in for math M1 vec3Cross until it lands). */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/** `a x b` (right-handed). */
export function ikCross(a: Vec3, b: Vec3): Vec3 {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}
